import {CommonModule, isPlatformBrowser, isPlatformServer} from '@angular/common';
import {Component, ElementRef, Inject, OnInit, PLATFORM_ID} from '@angular/core';
import {ActivatedRoute, NavigationEnd, Router, RouterOutlet} from '@angular/router';
import {MomentDateModule} from '@aposin/ng-aquila/moment-date-adapter';
import moment from 'moment';
import 'moment/locale/it';
import {Observable, filter, map, of, switchMap, take, tap} from 'rxjs';
import {ApiLoaderComponent} from './components/api-loader/api-loader.component';
import {FooterComponent} from './components/layout/footer/footer.component';
import {HeaderComponent} from './components/layout/header/header.component';
import {HeaderEnum} from './enums/routes-header.enum';
import {AnalyticsService} from './services/analytics/analytics.service';
import {PageTypeService} from './services/page-type/page-type.service';
import {ReloadPageService} from './services/reload-page/reload-page.service';
import {MetaHandlerService} from './services/meta-handler/meta-handler.service';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  providers: [],
  imports: [
    RouterOutlet,
    CommonModule,
    FooterComponent,
    HeaderComponent,
    MomentDateModule,
    ApiLoaderComponent,
  ],
})
export class AppComponent implements OnInit {
  public type: string = '';
  // public isBigFooter: boolean = false;
  // headerToGet!: Observable<keyof typeof HeaderEnum>;

  results$: Observable<{
    isBigFooter: boolean;
    showInformationFooter: boolean,
    headerToGet: HeaderEnum;
  }> = of({
    isBigFooter: false,
    showInformationFooter: true,
    headerToGet: HeaderEnum[this.pageTypeService.getTypePage()],
  });

  currentRoute!: string;
  public HeaderEnum = HeaderEnum;

  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    private router: Router,
    private route: ActivatedRoute,
    private analytics: AnalyticsService,
    private pageTypeService: PageTypeService,
    private el: ElementRef,
    private reloadPageService: ReloadPageService,
    private metaHandlerService: MetaHandlerService,
  ) {
    if(isPlatformBrowser(this.platformId)) this.setAnalytics();
  }
  ngOnInit() {
    moment.locale('it');
    const postDataAttr = this.el.nativeElement.getAttribute('post-data');
    if (postDataAttr) {
      const postData = JSON.parse(postDataAttr);
      this.pageTypeService.setPostRequestData(postData);
      // Handle the postData as needed
    }

    this.results$ = this.router.events.pipe(
      filter((event): event is NavigationEnd => event instanceof NavigationEnd),
      tap((event) => {
        this.reloadPageService.setCurrentUrl(event.url);
      }),
      switchMap(() => this.getChild(this.route).data),
      map((data) => {
        const type: keyof typeof HeaderEnum = data['type'];

        if (type) {
          this.pageTypeService.setTypePage(type);
        }

        if (isPlatformServer(this.platformId)) this.metaHandlerService.updateTags(type);

        const isBigFooter = data['isBigFooter']!;
        const showInformationFooter = data['showInformationFooter']?? true;
        this.analytics.updateDigitalData(data);
        return {isBigFooter, showInformationFooter};
      }),
      switchMap((data) =>
        this.pageTypeService.typePage$.pipe(
          take(1),
          map((typePage: keyof typeof HeaderEnum) => {
            return {...{headerToGet: HeaderEnum[typePage]}, ...data};
          }),
        ),
      ),
    );
  }

  getChild(route: ActivatedRoute): ActivatedRoute {
    if (route.firstChild) {
      return this.getChild(route.firstChild);
    } else {
      return route;
    }
  }

  setAnalytics() {
    this.analytics.injectAdobeLaunchScript();
  }
}
